import { render, staticRenderFns } from "./StageButton.vue?vue&type=template&id=6cb60ca3&scoped=true&"
import script from "./StageButton.vue?vue&type=script&lang=js&"
export * from "./StageButton.vue?vue&type=script&lang=js&"
import style0 from "./StageButton.vue?vue&type=style&index=0&id=6cb60ca3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb60ca3",
  null
  
)

export default component.exports